export const aliases = {
  "Flowing Wells Irrigation District": "Flowing Wells",
  "Green Valley Domestic Water Improvement District": "Green Valley",
  "Metropolitan Domestic Water Improvement District": "Metro",
  "Vail Water Co.": "Vail Water",
  "Tonto Hills Domestic Water Improvement District": "Tonto Hills",
  "Chaparral City Water Co.": "Chaparral City",
  "Arizona Water Co. (Pinal)": "Pine Water",
  "Arizona Water Co. (Superstition)": "Superstition System",
  "Arizona Water Co. (Superstition System)": "Superstition System",
  "Superstition System": "Arizona Water Co. (Superstition)",
  "Spanish Trail Water Co.": "Spanish Trail",
  "EPROC (San Tan)": "Johnson Utilities",
  "EPCOR (Paradise Valley)": "Paradise Valley",
  "EPCOR (Sun City)": "Sun City",
  "EPCOR (Sun City West)": "Sun City - West",
  "Circle City Water Co.": "Circle City",
  "EPCOR (Agua Fria)": "Aqua Fria",
  "Arizona Water Co. (White Tank)": "White Tank",
  Tonopah: "Maricopa County",
};

export const alias_entity_id_mapping = {
  Phoenix: 1,
  "Arizona Water Co. (Superstition System)": 4,
  "Arizona Water Co. (Pinal)": 3,
  // "AZ Water Co. - Coolidge": 3,
  "Arizona Water Co.(White Tank)": 2,
  Avondale: 5,
  Buckeye: 6,
  "Carefree Water Co.": 7,
  "Cave Creek": 8,
  Chandler: 9,
  "EPCOR- Chaparral City": 11,
  "Circle City Water Co.": 11,
  "Green Valley": 12,
  "EPCOR Anthem": 13,
  "El Mirage": 14,
  Eloy: 15,
  "EPCOR (Agua Fria)": 16,
  "EPCOR (Paradise Valley)": 17,
  "EPCOR (Sun City)": 18,
  "EPCOR (Sun City West)": 19,
  "EPCOR (San Tan)": 20,
  Florence: 21,
  "Flowing Wells Irrigation District": 22,
  Gilbert: 23,
  Glendale: 24,
  Goodyear: 25,
  Marana: 26,
  Mesa: 27,
  "Metropolitan Domestic Water Improvement District": 28,
  "Oro Valley": 29,
  Peoria: 30,
  "Apache Junction": 31,
  "Queen Creek": 32,
  "Rio Verde Utilities": 33,
  Scottsdale: 34,
  "Spanish Trail Water Co.": 35,
  Surprise: 36,
  Tempe: 37,
  "Tonto Hills Domestic Water Improvement District": 38,
  Tucson: 39,
  "Vail Water Co.": 40,
  Tonopah: 41,
  "San Carlos Apache Tribe": 42,
  "Fort McDowell Indian Community": 43,
  "Salt River Pima-Maricopa Indian Community": 44,
  "Gila River Indian Community": 45,
  "Ak-Chin Indian Community": 46,
  "Tohono O'odham Nation": 17,
  "Tohono O'odham Reservation": 73,
  "Tohono O'odham Trust Land" : 76,
  "Pascua Yaqui Tribe": 48,
  "Camp Verde (Yavapai-Apache)": 49,
  "Tonto Apache Tribe": 50,
  "Arizona State Land Department": 51,
  "Bullhead City": 52,
  "Cibola NWR": 53,
  "Cibola Valley Irrigation and Drainage District": 54,
  "City of Yuma": 73,
  "Cocopah Indian Tribe": 56,
  "Colorado River Indian Tribes": 57,
  "Fort Mojave Indian Tribe": 58,
  "Fort Yuma/Quechan Tribe": 59,
  "Imperial National Wildlife Refuge": 60,
  "City of Lake Havasu": 61,
  "Mohave County Water Authority": 62,
  "Mohave Valley Irrigation and Drainage District": 63,
  "North Gila Valley": 64,
  "Town of Parker": 65,
  "Wellton-Mohawk Irrigation": 66,
  "Unit B": 67,
  "Yuma County Water Users Association": 68,
  "Yuma Mesa Division Gila": 69,
};

export const western_arizona_shapes_included = {
  "Bullhead City": 52,
  "City of Yuma": 73,
  "Cocopah Indian Tribe": 56,
  "Colorado River Indian Tribes": 57,
  "Fort Mojave Indian Tribe": 58,
  "Fort Yuma Indian Reservation": 59,
  "Lake Havasu City": 61,
  "Town of Parker": 65,
};

export const western_arizona_irrigation_districts = {
  "Cibola NWR": 53,
  "Imperial National Wildlife Refuge": 60,
  "Mohave Valley Irrigation and Drainage District": 63,
  "North Gila Valley": 64,
  "Wellton-Mohawk Irrigation": 66,
  "Unit B": 67,
  "Yuma County Water Users Association": 68,
  "Yuma Mesa Division Gila": 69,
};

export const irrigation_name_mapping = {
  "New Magma Irrigation and Drainage District":
    "New Magma Irrigation and Drainage District",
  "Roosevelt Irrigation District": "Roosevelt Irrigation District",
  "Roosevelt Water Conservation District":
    "Roosevelt Water Conservation District",
  "Central Arizona Irrigation and Drainage District":
    "Central Arizona Irrigation and Drainage District",
  "Maricopa Water District": "Maricopa Water District",
  "Queen Creek Irrigation District": "Queen Creek Irrigation District",
  "Hohokam Irrigation and Drainage District":
    "Hohokam Irrigation and Drainage District",
  "Maricopa-Stanfield Irrigation and Drainage District":
    "Maricopa-Stanfield Irrigation and Drainage District",
  "Cortaro-Marana Water Users Association":
    "Cortaro-Marana Water Users Association",
  "Tonopah Irrigation District": "Tonopah Irrigation District",
  "Salt River Valley Water Users Association":
    "Salt River Valley Water Users Association",
  "Buckeye Water Conservation and Drainage District":
    "Buckeye Water Conservation and Drainage District",
  "BKW Farms": "BKW Farms",
  "Farmers Investment Company": "Farmers Investment Company",
  "Kai Farms": "Kai Farms",
  "Cibola NWR": "Cibola National Wildlife Refuge",
  "Cibola Valley Irrigation & Drainage District":
    "Cibola Valley Irrigation and Drainage District",
  "Imperial National Wildlife Refuge": "Imperial National Wildlife Refuge",
  "Mohave Valley Irrigation and Drainage District":
    "Mohave Valley Irrigation and Drainage District",
  "North Gila Valley": "North Gila Valley",
  "Unit B": "Unit B",
  "Yuma County Water Users Association": "Yuma County Water Users Association",
  "Yuma Mesa Division Gila": "Yuma Mesa Division Gila",
  "Wellton-Mohawk Irrigation":
    "Wellton-Mohawk Irrigation and Drainage District",
};

export const irrigation_use_name_mapping = {
  colorado_river: "Colorado River",
  groundwater: "Groundwater",
  other_river_water: "Other River Water",
  reclaimed_water: "Reclaimed Water",
  salt_and_verde: "Salt & Verde",
};

export const decimalRoundHelper = (num, places = 2) => {
  places = Math.pow(10, places);
  return Math.round(num * places) / places;
};

export function calculateLegendLabels(max, min) {
  let percentChange = max - min;

  const difference = percentChange / 4;
  const legendLabels = [decimalRoundHelper(min, 2)];
  let current = decimalRoundHelper(min, 2);
  for (let i = 0; i < 4; i++) {
    legendLabels.push(decimalRoundHelper((current += difference), 2));
  }
  var i = 0;
  var j = 1;
  // ensures that no bucket spans from negative to positive
  while (j < 5) {
    if (legendLabels[i] < 0 && legendLabels[j] > 0) {
      legendLabels[i] = 0;
    }
    i++;
    j++;
  }

  console.debug("legendLabels", legendLabels);
  const legendLabels1 = [-75, -50, -25, 0, 341];

  return legendLabels1;
}

export function generateStaticLegendLabels() {
  const legendLabels = [-75, -50, -25, 0, 341];
  return legendLabels;
}
